import { MapPin, MessageCircle, Navigation, Clock } from 'lucide-react';

const hours = [
  { day: 'Segunda-feira', status: 'Fechado' },
  { day: 'Terça-feira', status: 'A partir das 18h00' },
  { day: 'Quarta-feira', status: 'A partir das 18h00' },
  { day: 'Quinta-feira', status: 'A partir das 18h00' },
  { day: 'Sexta-feira', status: 'A partir das 18h00' },
  { day: 'Sábado', status: 'A partir das 18h00' },
  { day: 'Domingo', status: 'A partir das 18h00' },
];

export default function LocationSection() {
  return (
    <section id="localizacao" className="py-16 md:py-24 bg-cream-100">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16 reveal">
            <span className="inline-block text-gold-500 text-xs font-semibold tracking-widest uppercase mb-3">
              ONDE ESTAMOS
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown-900 mb-4">
              Localização e Horário
            </h2>
            <p className="text-brown-600 text-base md:text-lg max-w-2xl mx-auto">
              Venha nos visitar na Varjota, um dos bairros mais badalados de Fortaleza.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            {/* Map */}
            <div className="reveal reveal-left">
              <div className="relative rounded-2xl overflow-hidden shadow-xl bg-cream-200 aspect-[4/3] lg:aspect-auto lg:h-full min-h-[300px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.3108!2d-38.4976!3d-3.7371!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM8KwNDQnMTMuNyJTIDM4wrAyOSc1MS4zIlc!5e0!3m2!1spt-BR!2sbr!4v1700000000000"
                  width="100%"
                  height="100%"
                  style={{ border: 0, minHeight: '300px' }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Localização Buteco do Baiano"
                  className="w-full h-full"
                ></iframe>
              </div>
            </div>

            {/* Info */}
            <div className="reveal reveal-right">
              {/* Address */}
              <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm mb-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gold-500/10 text-gold-500 flex-shrink-0">
                    <MapPin size={24} />
                  </div>
                  <div>
                    <h3 className="font-heading text-lg font-bold text-brown-900 mb-1">Endereço</h3>
                    <p className="text-brown-600 text-sm leading-relaxed">
                      Rua 8 de Setembro, 1444 - Varjota<br />
                      Fortaleza - CE, 60175-210, 60160-090
                    </p>
                    <div className="flex flex-wrap gap-3 mt-4">
                      <a
                        href="https://www.google.com/maps/dir/?api=1&destination=-3.7371,-38.4976"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-4 py-2 bg-brown-900 text-white text-sm font-semibold rounded-full hover:bg-brown-800 transition-colors whitespace-nowrap"
                      >
                        <Navigation size={14} />
                        Abrir rotas
                      </a>
                      <a
                        href="https://wa.me/5585987413961?text=Olá!%20Vim%20pelo%20site%20do%20Buteco%20do%20Baiano%20e%20gostaria%20de%20mais%20informações."
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-4 py-2 bg-whatsapp-500 text-white text-sm font-semibold rounded-full hover:bg-whatsapp-600 transition-colors whitespace-nowrap"
                      >
                        <MessageCircle size={14} />
                        WhatsApp
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Hours */}
              <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gold-500/10 text-gold-500 flex-shrink-0">
                    <Clock size={24} />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-heading text-lg font-bold text-brown-900 mb-3">Horário de Funcionamento</h3>
                    <div className="space-y-2">
                      {hours.map((h) => (
                        <div key={h.day} className="flex items-center justify-between py-2 border-b border-cream-200 last:border-0">
                          <span className="text-brown-700 text-sm">{h.day}</span>
                          <span className={`text-sm font-medium ${h.status === 'Fechado' ? 'text-red-500' : 'text-gold-600'}`}>
                            {h.status}
                          </span>
                        </div>
                      ))}
                    </div>
                    <p className="text-brown-500 text-xs mt-4">
                      Consulte o horário atualizado pelo Google ou WhatsApp antes de visitar.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}